import React from 'react';
import { func, number, string, bool, arrayOf } from 'prop-types';

import withSpinner from '~components/Spinner';

import TabBar from './components/TabBar';
import { tabDataPropTypes } from './propTypes';

function Tabs({
  children,
  tabBarClassName,
  tabData,
  currentTabId,
  overrideClasses,
  onTabChange,
  lineSeparator,
  notFullWidth
}) {
  return (
    <>
      <TabBar
        tabs={tabData}
        className={tabBarClassName}
        currentTabId={currentTabId}
        overrideClasses={overrideClasses}
        onTabClick={onTabChange}
        lineSeparator={lineSeparator}
        notFullWidth={notFullWidth}
      />
      {children && children[currentTabId]}
    </>
  );
}

Tabs.propTypes = {
  currentTabId: number.isRequired,
  onTabChange: func.isRequired,
  lineSeparator: bool,
  notFullWidth: bool,
  overrideClasses: bool,
  tabBarClassName: string,
  tabData: arrayOf(tabDataPropTypes)
};

export default withSpinner({
  WrappedComponent: Tabs
});
